import { render } from "./SectionArtists.vue?vue&type=template&id=3f258c17&scoped=true"
import script from "./SectionArtists.vue?vue&type=script&lang=js"
export * from "./SectionArtists.vue?vue&type=script&lang=js"

import "./SectionArtists.vue?vue&type=style&index=0&id=3f258c17&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f258c17"]])

export default __exports__